import React, { Component, Fragment } from 'react';
import { compose, defaultTo, forEach, forEachObjIndexed, groupBy, path, map, isEmpty } from 'ramda';
import PropTypes from 'prop-types';
import { withFormik } from 'formik';
import Select from 'react-select';

import { apiUpdateProfile } from '../../../api/user';
import { handleError, handleSuccess } from '../../../util/forms';
import { apiGetMilitaryInstallations } from '../../../api/military';
import { isNilOrEmpty } from '../../../util/redux';

import EditField from '../../../components/Forms/EditField';
import Radio from '../../../components/Forms/Radio';
import Checkbox from '../../../components/Forms/Checkbox';

class ProfessionalInfo extends Component {
  static propTypes = {
    areasOfExpertise: PropTypes.array,
    workAreas: PropTypes.array,
    updateUser: PropTypes.func,
    user: PropTypes.object,
  };

  state = {
    loaded: false,
    militaryInstallations: [],
  };

  constructor(props) {
    super(props);

    apiGetMilitaryInstallations().then(({ data }) => this.setState({ loaded: true, militaryInstallations: data }));
  }

  render() {
    const {
      values,
      handleBlur,
      handleChange,
      handleSubmit,
      isSubmitting,
      isValid,
      setFieldValue,
      status,
      workAreas,
      areasOfExpertise,
      errors,

      headerClass,
      FooterComponent,
      footerProps,
      hideAFCPEPreferences,
    } = this.props;
    const { loaded, militaryInstallations } = this.state;

    if (!loaded) return <noscript />;
    const requiredString = hideAFCPEPreferences ? '*' : '';

    return (
      <form>
        <h2 className={headerClass}>Employment Information</h2>
        <EditField
          name="organization"
          label={`Organization${requiredString}`}
          status={status}
          onChange={handleChange}
          onBlur={handleBlur}
          value={values.organization}
          error={errors.organization}
        />
        <EditField
          name="jobTitle"
          label={`Job Title${requiredString}`}
          status={status}
          onChange={handleChange}
          onBlur={handleBlur}
          value={values.jobTitle}
          error={errors.jobTitle}
        />

        <label className="col-form-label">Professional Area of Work{requiredString} (select one)</label>
        {workAreas.map((workArea) => (
          <div key={workArea.id} className="form-group row ml-3">
            <div className="col-md-3">
              <Radio
                name="primaryWorkAreaCategoryId"
                value={workArea.id}
                checked={values.primaryWorkAreaCategoryId}
                label={workArea.name}
                onChange={handleChange}
              />
            </div>
            <div className="col-md-7">
              {values.primaryWorkAreaCategoryId == workArea.id && (
                <Select
                  multi
                  disabled={values.primaryWorkAreaCategoryId != workArea.id}
                  onChange={(value) => setFieldValue(`primaryWorkAreas`, value)}
                  options={workArea.workAreas.map((area) => ({
                    value: area.id,
                    label: area.name,
                    category: area.workAreaCategoryId,
                  }))}
                  value={values.primaryWorkAreas.filter((area) => area.category == values.primaryWorkAreaCategoryId)}
                />
              )}
              {workArea.name.toLowerCase().indexOf('military') != -1 &&
                values.primaryWorkAreaCategoryId == workArea.id && (
                  <Select
                    className="mt-3"
                    simpleValue
                    placeholder="Military Installation"
                    onChange={(value) => setFieldValue('militaryInstallationId', value)}
                    options={militaryInstallations.map((area) => ({ value: area.id, label: area.name }))}
                    value={values.militaryInstallationId}
                  />
                )}
            </div>
          </div>
        ))}

        <label className="col-form-label">Years of Service{requiredString}</label>
        <div className="form-group row ml-3">
          <div className="col-md-10">
            <Radio
              name="yearsOfService"
              label="0-2 years"
              value="0-2"
              checked={values.yearsOfService}
              onBlur={handleBlur}
              onChange={handleChange}
            />
            <Radio
              name="yearsOfService"
              label="3-5 years"
              value="3-5"
              checked={values.yearsOfService}
              onBlur={handleBlur}
              onChange={handleChange}
            />
            <Radio
              name="yearsOfService"
              label="6-10 years"
              value="6-10"
              checked={values.yearsOfService}
              onBlur={handleBlur}
              onChange={handleChange}
            />
            <Radio
              name="yearsOfService"
              label="11-15 years"
              value="11-15"
              checked={values.yearsOfService}
              onBlur={handleBlur}
              onChange={handleChange}
            />
            <Radio
              name="yearsOfService"
              label="16-20 years"
              value="16-20"
              checked={values.yearsOfService}
              onBlur={handleBlur}
              onChange={handleChange}
            />
            <Radio
              name="yearsOfService"
              label="20+ years"
              value="20+"
              checked={values.yearsOfService}
              onBlur={handleBlur}
              onChange={handleChange}
            />
          </div>
        </div>

        <hr />

        <h2>
          Secondary Professional Areas of Work <span className="extra-small">(Optional, select all that apply)</span>
        </h2>
        {workAreas.map((workArea) => (
          <div key={workArea.id} className="form-group row">
            <div className="col-md-3">
              <Checkbox
                name={`workAreaCategories[${workArea.id}]`}
                label={workArea.name}
                checked={defaultTo(false, values.workAreaCategories[workArea.id])}
                onBlur={handleBlur}
                onChange={handleChange}
              />
            </div>
            <div className="col-md-7">
              {values.workAreaCategories[workArea.id] && (
                <Select
                  multi
                  disabled={!values.workAreaCategories[workArea.id]}
                  onChange={(value) => setFieldValue(`workAreas[${workArea.id}]`, value)}
                  options={workArea.workAreas.map((area) => ({ value: area.id, label: area.name }))}
                  value={values.workAreas[workArea.id]}
                />
              )}
              {workArea.name.toLowerCase().indexOf('military') != -1 && values.workAreaCategories[workArea.id] && (
                <Select
                  className="mt-3"
                  simpleValue
                  placeholder="Military Installation"
                  onChange={(value) => setFieldValue('militaryInstallationId', value)}
                  options={militaryInstallations.map((area) => ({ value: area.id, label: area.name }))}
                  value={values.militaryInstallationId}
                />
              )}
            </div>
          </div>
        ))}
        <div className="form-group row">
          <div className="col-md-3">
            <Checkbox name="other" label="Other" checked={values.other} onBlur={handleBlur} onChange={handleChange} />
          </div>
          <div className="col-md-7">
            {values.other && (
              <EditField
                block
                name="areasOfWorkOther"
                status={status}
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.areasOfWorkOther}
              />
            )}
          </div>
        </div>

        <hr />

        {!hideAFCPEPreferences && (
          <Fragment>
            <h2>Find an Sage Financial Solutions Professional Settings</h2>

            <Checkbox
              name="provideCounselingServices"
              label="I am interested in being contacted for financial counseling, coaching, or education services."
              checked={values.provideCounselingServices}
              onBlur={handleBlur}
              onChange={handleChange}
            />

            <Checkbox
              name="offerVirtualCounseling"
              label="I offer virtual services."
              checked={values.offerVirtualCounseling}
              onBlur={handleBlur}
              onChange={handleChange}
            />

            <Checkbox
              name="offerLocalCounseling"
              label="I offer local services."
              checked={values.offerLocalCounseling}
              onBlur={handleBlur}
              onChange={handleChange}
            />

            <Checkbox
              name="offerGroupWorkshops"
              label="I offer group workshops."
              checked={values.offerGroupWorkshops}
              onBlur={handleBlur}
              onChange={handleChange}
            />

            <EditField
              as={Select}
              bare
              multi
              name="areasOfExpertise"
              label="Areas Of Expertise (select all that apply)"
              status={status}
              onChange={(value) =>
                setFieldValue(
                  'areasOfExpertise',
                  value.map((area) => area.value),
                )
              }
              options={areasOfExpertise.map((area) => ({ value: area.id, label: area.name }))}
              value={values.areasOfExpertise}
            />

            <hr />
          </Fragment>
        )}

        {FooterComponent ? (
          <FooterComponent isValid={isValid} isSubmitting={isSubmitting} handleSubmit={handleSubmit} {...footerProps} />
        ) : (
          <div className="form-group row row mb-0">
            <div className="col-md-6 offset-md-4 text-right">
              <button
                type="submit"
                className="btn btn-primary"
                disabled={!isValid || isSubmitting}
                onClick={handleSubmit}
              >
                Save Changes
              </button>
            </div>
          </div>
        )}
      </form>
    );
  }
}

export default withFormik({
  handleSubmit: (payload, formProps) => {
    const { props } = formProps;
    const workAreaCategories = [];
    const workAreas = [];
    forEachObjIndexed((value, key) => {
      if (value) {
        workAreaCategories.push(Number(key));
        forEach((workArea) => workAreas.push(workArea.value), defaultTo([], path(['workAreas', key], payload)));
      }
    }, payload.workAreaCategories);

    apiUpdateProfile({
      ...payload,
      workAreaCategories,
      workAreas,
      primaryWorkAreas: payload.primaryWorkAreas.map((area) => area.value),
    })
      .then(({ data }) => props.updateUser(data))
      .then(() => handleSuccess(formProps))
      .then(() => props.afterUpdate && props.afterUpdate())
      .catch((err) => handleError(formProps, err));
  },
  mapPropsToValues: ({ user }) => {
    const workAreaCategories = {};
    const workAreas = compose(
      groupBy((workArea) => workArea.workAreaCategoryId),
      map((workArea) => ({
        value: workArea.id,
        label: workArea.name,
        workAreaCategoryId: workArea.workAreaCategoryId,
      })),
      defaultTo([]),
    )(user.workAreas);
    user.workAreaCategories.forEach((workAreaCategory) => (workAreaCategories[workAreaCategory.id] = true));
    const areasOfWorkOther = defaultTo('', user.areasOfWorkOther);
    const primaryWorkAreas = defaultTo(
      [],
      user.primaryWorkAreas.map((workArea) => ({
        value: workArea.id,
        label: workArea.name,
        category: workArea.workAreaCategoryId,
      })),
    );

    return {
      organization: defaultTo('', user.organization),
      jobTitle: defaultTo('', user.jobTitle),
      yearsOfService: defaultTo('', user.yearsOfService),
      militaryInstallationId: defaultTo('', user.militaryInstallationId),
      workAreas,
      workAreaCategories,
      primaryWorkAreaCategoryId: defaultTo('', user.primaryWorkAreaCategoryId),
      primaryWorkAreas,
      other: !!areasOfWorkOther,
      areasOfWorkOther: areasOfWorkOther,
      areasOfExpertise: defaultTo([], user.areasOfExpertise).map((area) => area.id),
      provideCounselingServices: defaultTo(false, user.provideCounselingServices),
      offerVirtualCounseling: defaultTo(false, user.offerVirtualCounseling),
      offerLocalCounseling: defaultTo(false, user.offerLocalCounseling),
      offerGroupWorkshops: defaultTo(false, user.offerGroupWorkshops),
    };
  },
  validate: (values, props) => {
    const errors = {};
    if (props.hideAFCPEPreferences) {
      if (isNilOrEmpty(values.organization)) errors.organization = 'Required';
      if (isNilOrEmpty(values.jobTitle)) errors.jobTitle = 'Required';
      if (isNilOrEmpty(values.yearsOfService)) errors.yearsOfService = 'Required';
      if (isNilOrEmpty(values.primaryWorkAreaCategoryId)) errors.primaryWorkAreaCategoryId = 'Required';
      if (isNilOrEmpty(values.primaryWorkAreas)) errors.primaryWorkAreas = 'Required';
    }
    return errors;
  },
  isInitialValid: ({ initialValues, validate }) => isEmpty(validate(initialValues)),
  validateOnChange: true,
})(ProfessionalInfo);
